export default __webpack_public_path__ + "static/noodlefactory-681803a26d82457733144477085742da.webp";